import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteJobSynonymModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobSynonymModalContainer" */
      './DeleteJobSynonymModalContainer'
    ),
  loading: LoadingModal,
});
